import React from 'react'
import PropTypes from 'prop-types'
import { currencyFormat } from 'utils/format'
import {
  InputForm,
  SelectForm,
} from 'components/Form/components'
import DeleteIcon from '@material-ui/icons/Delete'
import { Button } from 'ui-components/Button'
import { Container, Options, DeleteOption } from './styles'

export default function PaymentPlan(props) {
  const {
    paymentPlan,
    paymentMethodOptions,
    onSelectPlan,
    onSelectMethod,
    onChangeValue,
    onDelete,
  } = props

  const handleChangeValue = (evt) => {
    onChangeValue({
      plan: paymentPlan,
      value: evt.target.value,
    })
  }

  const handleChangePaymentMethod = (selectedOption) => {
    if (!selectedOption.value) return

    onSelectMethod({
      plan: paymentPlan,
      selectedOption,
    })
  }

  const handleSelectPlan = (selectedOption) => {
    onSelectPlan({
      plan: paymentPlan,
      selectedOption,
    })
  }

  const handleRemovePlan = () => {
    onDelete(paymentPlan)
  }

  return (
    <Container>
      <Options>
        <InputForm
          fullWidth
          label="Valor"
          type="text"
          name="name"
          value={currencyFormat(paymentPlan.value)}
          onChange={handleChangeValue}
        />
        <SelectForm
          label="Meio de pagamento"
          options={paymentMethodOptions}
          value={paymentPlan.selected_method_option}
          onChange={handleChangePaymentMethod}
          name="paymentMethod"
        />
        <SelectForm
          label="Parcela"
          options={paymentPlan.payment_plan_options}
          value={paymentPlan.selected_plan_option}
          onChange={handleSelectPlan}
          name="paymentPlan"
        />
      </Options>
      <DeleteOption>
        <Button
          buttonType="icon"
          color="secondary"
          onClick={handleRemovePlan}
        >
          <DeleteIcon />
        </Button>
      </DeleteOption>
    </Container>
  )
}

PaymentPlan.propTypes = {
  paymentPlan: PropTypes.objectOf(PropTypes.any).isRequired,
  paymentMethodOptions: PropTypes.arrayOf(PropTypes.object).isRequired,
  onSelectPlan: PropTypes.func.isRequired,
  onSelectMethod: PropTypes.func.isRequired,
  onChangeValue: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
}
